import { MAX_CUSTOM_ICONS, isCustomIconId, isIconData, isIconRef } from "../folder-icons";
import { MAX_VAULT_FILES, VaultError, assertObject, type RepositoryMetadata } from "./model";
import { relativePath } from "./paths";

export const defaultMetadata = (): RepositoryMetadata => ({
  pinned: [],
  checkpoint: { auto_minutes: 30 },
  icons: {},
  custom_icons: {},
});

/** Checks the folder icon changes in a metadata patch; null forgets an entry. */
export function validateIconPatch(icons: unknown, uploads: unknown): void {
  if (icons !== undefined) {
    assertObject(icons);
    if (Object.keys(icons).length > MAX_VAULT_FILES)
      throw new VaultError("invalid_request", "Too many folder icons.");
    for (const [folder, icon] of Object.entries(icons)) {
      relativePath(folder);
      if (icon !== null && !isIconRef(icon))
        throw new VaultError("invalid_request", "Invalid folder icon.");
    }
  }
  if (uploads !== undefined) {
    assertObject(uploads);
    // Room to forget every uploaded icon and add a full set in one patch.
    if (Object.keys(uploads).length > MAX_CUSTOM_ICONS * 2)
      throw new VaultError("invalid_request", "Too many uploaded icons.");
    for (const [id, data] of Object.entries(uploads))
      if (!isCustomIconId(id) || (data !== null && !isIconData(data)))
        throw new VaultError("invalid_request", "Invalid uploaded icon.");
  }
}

export function validateCheckpointMinutes(
  minutes: unknown,
): asserts minutes is number {
  if (
    !Number.isInteger(minutes) ||
    Number(minutes) < 1 ||
    Number(minutes) > 1440
  )
    throw new VaultError(
      "invalid_request",
      "Checkpoint interval must be 1–1440 minutes.",
    );
}
